import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from './AppRouter';



function App() {
  return (
    <Router>
      <div className="USE-APP">
        <main>
          <AppRoutes />
        </main>
      </div>
    </Router>
  );
}

export default App;
